import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, of, switchMap, tap } from 'rxjs';

import { EffectsBase } from '@ps/core-data-access';
import { ToastService } from '@ps/core-overlay';

import { CompanyMarginsService } from '../../../services/company-margins.service';
import { CompanyMarginsActions } from '../actions/company-margins.actions';

@Injectable()
export class CompanyMarginsEffects extends EffectsBase {
  private readonly _actions$ = inject(Actions);
  private readonly _service = inject(CompanyMarginsService);
  private readonly _toast = inject(ToastService);

  public readonly loadCompanyMargins$ = createEffect(() =>
    this._actions$.pipe(
      ofType(CompanyMarginsActions.loadCompanyMargins),
      switchMap(({ companyId }) =>
        this._service.getCompanyMargins(companyId).pipe(
          map((margins) =>
            CompanyMarginsActions.loadCompanyMarginsSuccess({ margins }),
          ),
          this.psCatchError(
            (error) =>
              of(
                CompanyMarginsActions.loadCompanyMarginsFailure({
                  error: error.message,
                }),
              ),
            { notify: true },
          ),
        ),
      ),
    ),
  );

  public readonly saveCompanyMargins$ = createEffect(() =>
    this._actions$.pipe(
      ofType(CompanyMarginsActions.saveCompanyMargins),
      switchMap(({ margins }) =>
        this._service.bulkSave(margins).pipe(
          tap(() => this._toast.success('Margins saved successfully')),
          map((saved) =>
            CompanyMarginsActions.saveCompanyMarginsSuccess({
              margins: saved,
            }),
          ),
          this.psCatchError(
            (error) =>
              of(
                CompanyMarginsActions.saveCompanyMarginsFailure({
                  error: error.message,
                }),
              ),
            { notify: true },
          ),
        ),
      ),
    ),
  );
}
